module.exports = __webpack_public_path__ + "img/logo-pamono.840c97e8.png";